import type { IDrawRequest } from 'pages/Borrower'
import { DrawRequestStatusBadge } from 'pages/Borrower/DrawRequest/drawRequestStatus'
import { Modal, PlainTable } from 'stories/components'
import { formatTime, getPrice2decimal, replaceNextLineToBr } from 'utils'

import { drawRequestForLine } from './drawRequestLine'

export const DrawRequestsDialog = ({
  value,
  title,
  lineValue,
  lineKey,
  requests,
  onClose,
}: {
  value: string
  title: string
  /** The budget line this dialog was opened on: its section's `value` and the cell's key. */
  lineValue: string
  lineKey: string
  requests: IDrawRequest[]
  onClose: Function
}) => {
  return (
    <Modal isOpen titleOkay="" title="Draw Requests" onClose={() => onClose()}>
      <div className="w-196">
        <p className="mb-4">
          Description:{' '}
          <span className="font-semibold">
            {value} / {title}
          </span>
        </p>
        <PlainTable
          header={['No', 'Name', 'Amount', 'Description', 'Requested At', 'Status']}
          data={requests.map((v, index) => {
            const line = drawRequestForLine(v, lineValue, lineKey)
            return [
              index + 1,
              `${v.firstName} ${v.lastName}`.trim(),
              `$${getPrice2decimal(line.amount)}`,
              <p dangerouslySetInnerHTML={{ __html: replaceNextLineToBr(line.description) }} />,
              formatTime(v.createdAt),
              <DrawRequestStatusBadge request={v} />,
            ]
          })}
        />
      </div>
    </Modal>
  )
}
